import React, { FC, forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { LinkTo } from './LinkTo';
import { CaretRight } from './icons/CaretRight';
import { CaretLeft } from './icons/CaretLeft';

export interface IconLinkProps {
  a11yTitle?: string;
  id?: string;
  className?: string;
  onClick?: any;
  target?: string;
  label?: string;
  disabled?: boolean;
  as?: any;
  url?: any;
  type?: 'button' | 'submit' | 'reset';
  arrowRight?: boolean;
  arrowLeft?: boolean;
  arrowLeftBack?: boolean;
  iconRight?: React.ReactNode;
  iconLeft?: React.ReactNode;
  children?: any;
  hideLabelOnMobile?: boolean;
  state?: any;
  eventName?: string;
  eventClickSection?: string;
  topAlignIcon?: boolean;
}

interface IconLinkStylesProps {
  $hideLabelOnMobile?: boolean;
  $topAlignIcon?: boolean;
}

const IconLinkStyles = styled.a<IconLinkStylesProps>`
  ${({ theme: { space, maxMedia }, $hideLabelOnMobile, $topAlignIcon }) => css`
    display: inline-flex;
    gap: ${space.xs};
    /* background: transparent; */
    cursor: pointer;
    align-items: center;

    svg {
      flex-shrink: 0;
      width: 24px;
      height: 24px;
    }

    // Top align icon

    ${$topAlignIcon &&
    css`
      align-items: flex-start;

      svg {
        margin-top: ${space.xs};
      }
    `}

    // Default styling

    ${$hideLabelOnMobile &&
    css`
      // Tablet < styles

      @media (max-width: ${maxMedia.md}) {
        span {
          display: none;
        }
      }
    `}
  `};
`;

export const IconLink: FC<React.PropsWithChildren<IconLinkProps>> = forwardRef(
  (
    {
      children,
      a11yTitle,
      id,
      className,
      onClick,
      disabled = false,
      as,
      url,
      target,
      label,
      type,
      arrowRight,
      arrowLeft,
      arrowLeftBack,
      iconLeft,
      iconRight,
      hideLabelOnMobile,
      state,
      eventName,
      eventClickSection,
      topAlignIcon,
      ...rest
    },
    ref
  ) => {
    // if (!label && !children) {
    //   return null;
    // }

    const handleClick = (...props) => {
      if (onClick) {
        onClick(...props);
      }
    };

    const IconLeft = iconLeft;
    const IconRight = iconRight;

    return (
      <IconLinkStyles
        ref={ref}
        as={!url ? 'button' : LinkTo}
        id={id}
        onClick={handleClick}
        className={className}
        to={url}
        aria-label={a11yTitle}
        type={type}
        disabled={disabled}
        aria-disabled={disabled}
        target={target}
        {...rest}
        $hideLabelOnMobile={hideLabelOnMobile}
        state={{ ...state }}
        $topAlignIcon={topAlignIcon}
      >
        {arrowLeft && !arrowLeftBack ? <CaretRight /> : ''}
        {arrowLeft && arrowLeftBack ? <CaretLeft /> : ''}
        {iconLeft && !arrowLeft ? IconLeft : ''}
        {label || children ? <span>{label || children}</span> : ''}
        {arrowRight && <CaretRight />}
        {iconRight && !arrowRight ? IconRight : ''}
      </IconLinkStyles>
    );
  }
);
